import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import ItemBox from '../../../components/itens/item';


function RemumeScreen() {
    return (
        <Fragment>
            <Head titulo="REMUME - Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/saude'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={3}>
                    <Col>
                        <ItemBox
                            titulo={"Lei Municipal Nº990/21"}
                            descricao={<Fragment>Institui no âmbito do Município de Macuco a obrigatoriedade na divulgação da relação de medicamentos, fabricação, lote e validade, disponíveis na rede pública de saúde e dá outras providências<br /><br /></Fragment>}
                            awesome={"faGavel"}
                            link={"../arquivos/lei/2021/Lei990.pdf"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Relação Municipal de Medicamentos Essenciais"}
                            descricao={<Fragment>Abaixo segue o link para o onde você pode realizar uma busca de medicamentos dentro do REMUME, referente ao ano de 2025<br /><br /></Fragment>}
                            awesome={"faPills"}
                            link={"remume/listar"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Relação Municipal de Medicamentos Essenciais"}
                            descricao={<Fragment>Abaixo segue o link para o documento contendo do REMUME completo, referente ao ano de 2025 e instruções de como obter acesso aos medicamentos<br /><br /></Fragment>}
                            awesome={"faFile"}
                            link={"../arquivos/docs/REMUME-2025.pdf"}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default RemumeScreen;